import React from "react";
import { ReactComponent as Passenger } from '../../../assets/icons/user.svg';
import { ReactComponent as Billing } from '../../../assets/icons/billing.svg';
import { ReactComponent as Payment } from '../../../assets/icons/payment.svg';
import { ReactComponent as Confirm } from '../../../assets/icons/confirm.svg';
import { ReactComponent as Pending } from '../../../assets/icons/pending.svg';
import { ReactComponent as Fail } from '../../../assets/icons/fail.svg';
import { useNavigate } from "react-router-dom";



const Breadcrumbs = ({ currentStep, orderStatus, noGoBack = false }) => {

  let EnjoyIcon = Confirm;

  if(orderStatus === "completed"){
    EnjoyIcon = Confirm;
  }
  if(orderStatus === "payment_pending"){
    EnjoyIcon = Pending;
  }

  if(orderStatus === "DECLINED" || orderStatus === "cancelled"){
    EnjoyIcon = Fail;
  }

  const steps = [
    { label: "Pasajeros", icon: Passenger, path: "/checkout/passengers/" },
    { label: "Facturación", icon: Billing, path: "/checkout/billing/" },
    { label: "Pago", icon: Payment, path: "/checkout/payments/" },
    { label: "Confirmación", icon: EnjoyIcon, path: "checkout/enjoy" },
  ];

  const navigate = useNavigate();


  const onBackButtonClick = ()=>{
    if(!noGoBack){
      const path = currentStep === 0 ? -1 : steps[currentStep - 1].path
      //console.log(path)
      navigate(path)
    }
  }

  return (
    <div className="breadcrumbs">
      <div className="breadcrumbs__container">
        <button onClick={onBackButtonClick} className={(noGoBack ? 'hidden' : '')}>
          <svg
            width="8"
            height="14"
            viewBox="0 0 8 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 1L1 7L7 13"
              stroke="#DEE0E3"
               strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className="breadcrumbs-items">
          {steps.map((step, index) => (
            <React.Fragment key={step.label}>
              <div className="breadcrumb-item">
                <div
                  className={`item-icon ${
                    index === currentStep
                      ? "current-step"
                      : index < currentStep
                      ? "previous-step"
                      : "next-step"
                  }`}
                >
                  <step.icon />
                </div>
                <span
                  className={`item-text`}
                >
                  {step.label}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`straight-line ${
                    index < currentStep ? "previous-step" : "next-step"
                  }`}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Breadcrumbs;
